import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const cache = {};

export function usePageContent(page, defaults = {}) {
  const [content, setContent] = useState(defaults);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (cache[page]) {
      setContent(prev => ({ ...prev, ...cache[page] }));
      setLoading(false);
      return;
    }
    const fetch = async () => {
      try {
        const { data } = await axios.get(`${API}/api/page-content/${page}`);
        if (data.content && Object.keys(data.content).length > 0) {
          cache[page] = data.content;
          setContent(prev => ({ ...prev, ...data.content }));
        }
      } catch (e) {
        // Use defaults silently
      }
      setLoading(false);
    };
    fetch();
  }, [page]);

  return { content, loading };
}

export function invalidateCache(page) {
  delete cache[page];
}
